<div>
  <app-sending *ngIf="sending"></app-sending>
  <app-title [title]="title"></app-title>
  <p class="c-texts-attention">＊は入力必須項目です</p>
  <app-input-table [formItems]="formItems"> </app-input-table>
  <div class="footer-button">
    <is-igx-button [buttonData]="registerButton" (click)="submit()"> </is-igx-button>
  </div>
</div>

<is-igx-dialog-message #messageDialog [messageCd]="'confirmRun'" (click)="dialogAction($event)"></is-igx-dialog-message>
